import fineTuneMultihubView from './fineTuneMultihubComponent.html';
import './fineTuneMultihubComponent.css';
import { filterObjects } from '../../matchesAllWords/matchesAllWords.js';

export function fineTuneMultihubComponent() {
	return {
		bindings: {
			model: '=',
			maxCheckboxes: '<',
		},
		controllerAs: 'vm',
		controller: fineTuneMultihubComponentCtrl,
		template: fineTuneMultihubView,
	};
}

export class fineTuneMultihubComponentCtrl {
	constructor($scope, Identity) {
		'ngInject';
		// save injections but assume bindings are not yet set
		this.$scope = $scope;
		this.Identity = Identity;
	}

	$onInit() {
		// general setup
		this.allHubs = this.Identity.hubChoices() || [];
		this.$scope.$watch('vm.model', this.readFromModel.bind(this));
		this.filter = '';
		this.readFromModel();
	}

	$onChanges(changes) {
		if (changes.maxCheckboxes && this.maxCheckboxes > 0) {
			this.runFilter();
		}
	}

	readFromModel() {
		let shouldCheck;
		if (typeof this.model !== 'string') {
			this.model = '';
		}
		if (this.model === 'account') {
			const currAccount = this.Identity.currentAffiliationId();
			shouldCheck = hub => hub.account_id == currAccount;
		} else if (this.model === 'current') {
			const currHub = this.Identity.currentClient().id;
			shouldCheck = hub => hub.id == currHub;
		} else if (this.model === 'mine') {
			shouldCheck = () => true;
		} else {
			const selected = this.model.split(',');
			shouldCheck = hub => selected.includes(String(hub.id));
		}
		this.allHubs.forEach(hub => (hub.checked = shouldCheck(hub)));
		this.runFilter();
	}

	writeToModel() {
		const selected = [];
		this.allHubs.forEach(hub => {
			if (hub.checked) {
				selected.push(hub.id);
			}
		});
		if (selected.length === this.allHubs.length) {
			this.model = 'mine';
		} else {
			this.model = selected.join(',');
		}
	}

	isAllChecked() {
		return this.model === 'mine' || this.allHubs.every(hub => hub.checked);
	}

	toggleAll() {
		if (this.isAllChecked()) {
			this.allHubs.forEach(hub => (hub.checked = false));
			this.model = '';
		} else {
			this.model = 'mine';
		}
		this.readFromModel();
	}

	clearFilter() {
		this.filter = '';
		this.runFilter();
	}

	runFilter() {
		const maxItems = this.maxCheckboxes || 100;
		if (this.filter === '') {
			this.numHiddenHubs = this.allHubs.length - maxItems;
			this.filteredHubs = this.allHubs.slice(0, maxItems);
		} else {
			this.filteredHubs = filterObjects(this.allHubs, this.filter, ['$search'], maxItems);
		}
	}

	toggleCheckbox(hub, evt) {
		hub.checked = evt.target.checked;
		this.writeToModel();
	}
}
